export const NAME = 'globalappstate';